export function sidebarToggle() {
  return (dispatch) => {
      dispatch({ type: 'LEFT_SIDEBAR_TOGGLE' });
  };
}



// WEBPACK FOOTER //
// ./src/actions/system.js